import { ChangeDetectorRef, Injectable } from '@angular/core';
import * as moment from 'moment';
import { AbstractControl, FormControl } from '@angular/forms';

@Injectable()

export class DateTimeService {
  public cd: ChangeDetectorRef = null;

  constructor() {
  }

  fixDateTimeManualInput(control: FormControl | AbstractControl, $event: any): void {
    if (control !== null) {
      if ($event.value !== null && typeof $event.value !== 'undefined') {
        // noinspection JSUnresolvedReference
        if (typeof $event.value._i !== 'undefined' && typeof $event.value._i === 'string') {
          // noinspection JSUnresolvedReference
          control.setValue(moment($event.value._i, 'DD-MM-YY HH:mm').toISOString());
        } else if (typeof $event.value._d !== 'undefined') {
          // noinspection JSUnresolvedReference
          control.setValue(moment($event.value._d, 'DD-MM-YY HH:mm').toISOString());
        } else if (typeof $event.value === 'object') {
          control.setValue(moment($event.value).toISOString());
        } else {
          throw new Error('Invalid date provided: ' + $event.value);
        }
      }

      if (
        typeof $event.value === 'undefined' && typeof $event.target !== 'undefined' &&
        typeof $event.target.value !== 'undefined' && typeof $event.target.value === 'string'
      ) {
        control.setValue(moment($event.target.value, 'DD-MM-YY HH:mm').toISOString());
      }
    }

    control.updateValueAndValidity();

    if (this.cd !== null) {
      this.cd.detectChanges();
    }
  }
}
